import { all } from 'redux-saga/effects';

import createSecret from './createSecret';
import deleteSecrets from './deleteSecrets';
import fetchViewFilter from './fetchViewFilter';
import getSecretTOTP from './getSecretTOTP';
import ignoreReportSecret from './ignoreReportSecret';
import loadSecretsFlow from './loadSecretsFlow';
import readSecret from './readSecret';
import removeSecret from './removeSecret';
import seedViewFilter from './seedViewFilter';
import shareSecret from './shareSecret';
import updateSecret from './updateSecret';

export function* saga() {
    yield all([
        loadSecretsFlow(),
        deleteSecrets(),
        createSecret(),
        readSecret(),
        updateSecret(),
        removeSecret(),
        ignoreReportSecret(),
        shareSecret(),
        getSecretTOTP(),
        fetchViewFilter(),
        seedViewFilter(),
    ]);
}
